import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-9dcb05c2")
const _hoisted_1 = { class: "body_style" }
const _hoisted_2 = { class: "title_style" }
const _hoisted_3 = { class: "tab_bar_style" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "table_style" }
_popScopeId()

import { onMounted, ref } from 'vue'
import { getDataOverviewTotalCount } from '@/services/data-overview'
import CountCard from './components/CountCard.vue'
import CoursewareList from './components/CoursewareList.vue'
import TeacherList from './components/TeacherList.vue'
import SchoolList from './components/SchoolList.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const info = ref<any>()

const tabOpts = [
  { value: 'courseware', label: '课件人气排行榜' },
  { value: 'school', label: '学校贡献排行榜' },
  { value: 'teacher', label: '教师贡献排行榜' }
]

const TabTypeMap = {
  SCHOOL: 'school',
  COURSEWARE: 'courseware',
  TEACHER: 'teacher'
}

const currentTab = ref<string>(TabTypeMap.COURSEWARE)

const tabSelctStyle = {
  color: '#1794fa',
  // border: '1px solid #1794fa',
  // padding: '10px 9px',
  borderBottom: '0px'
}

const handleGetTotalCount = async () => {
  try {
    const data = await getDataOverviewTotalCount()
    const newAdd = [
      {
        label: '平台资源',
        value: data?.last_month_official_new_resource_count as number || 0
      },
      {
        label: '区域资源',
        value: data?.last_month_ins_new_resource_count as number || 0
      }
    ]
    const totalCount = [
      {
        label: '平台资源',
        value: data?.total_official_resource_count as number || 0
      },
      {
        label: '区域资源',
        value: data?.total_ins_resource_count as number || 0
      }
    ]
    const shareInfo = [
      { label: '课件下载总次数', value: data?.total_ins_courseware_download_num as number || 0 },
      { label: '课件分享总次数', value: data?.total_ins_courseware_share_count as number || 0 }
    ]
    info.value = { newAdd: newAdd, totalCount: totalCount, shareInfo }
  } catch (err) {
    console.log(err)
    info.value = { newAdd: [], totalCount: [] }
  }
}
const handleClickTab = (value: string) => {
  if (currentTab.value !== value) {
    currentTab.value = value
  }
}

onMounted(() => {
  handleGetTotalCount()
})


return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_row, { gutter: [16, 16] }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            xxl: 8,
            xl: 12,
            sm: 24
          }, {
            default: _withCtx(() => [
              _createVNode(CountCard, {
                title: "最近新增",
                color: "#796fd2",
                datasource: info.value?.newAdd || []
              }, null, 8, ["datasource"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, {
            xxl: 8,
            xl: 12,
            sm: 24
          }, {
            default: _withCtx(() => [
              _createVNode(CountCard, {
                title: "资源总量",
                color: "#2daffe",
                datasource: info.value?.totalCount || []
              }, null, 8, ["datasource"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, {
            xxl: 8,
            xl: 12,
            sm: 24
          }, {
            default: _withCtx(() => [
              _createVNode(CountCard, {
                title: "分享和下载",
                color: "#41c781",
                large: true,
                datasource: info.value?.shareInfo || []
              }, null, 8, ["datasource"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabOpts, (tabInfo) => {
          return _createElementVNode("span", {
            key: tabInfo.value,
            class: "tab_style",
            style: _normalizeStyle(currentTab.value === tabInfo.value ? tabSelctStyle : {}),
            onClick: () => handleClickTab(tabInfo.value)
          }, _toDisplayString(tabInfo.label), 13, _hoisted_4)
        }), 64))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_a_card, { class: "card_body" }, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(CoursewareList, null, null, 512), [
              [_vShow, currentTab.value === TabTypeMap.COURSEWARE]
            ]),
            _withDirectives(_createVNode(TeacherList, null, null, 512), [
              [_vShow, currentTab.value === TabTypeMap.TEACHER]
            ]),
            _withDirectives(_createVNode(SchoolList, {
              show: currentTab.value === TabTypeMap.SCHOOL
            }, null, 8, ["show"]), [
              [_vShow, currentTab.value === TabTypeMap.SCHOOL]
            ])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})